import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAggregate } from 'hooks';
import { Context as AuthContext } from 'contexts/auth';
import { Config } from 'configs';
import { getDateInCustomTimezone } from 'utils/dateManagement';
import { PageTitle } from 'components/layouts/pageTitle';
import { ListLayout } from 'components/layouts/listLayout';

export const ReviewDetails = () => {
  const { state: auth } = useContext(AuthContext);

  const params = useParams();
  const { id } = params;

  const requestData = {
    collectionName: Config.DATA.COLLECTIONS.REVIEWS,
    aggregateId: Config.DATA.AGGREGATES.GET_REVIEW_DETAILS,
    secretKey: auth.token,
    filter: { company: auth.company?.company, reviewId: id },
    aggregateIdV2: 'AdminGetReviewDetails',
    companyIdForV2: auth.company?.company,
  };

  const [, reviews, isLoading] = useAggregate(requestData);

  const review = reviews && reviews.length > 0 ? reviews[0] : null;

  return (
    <ListLayout isLoading={isLoading}>
      {!!review && (
      <>
        <PageTitle
          title="Review"
          breadcrumbs={[
            { path: '/reviews', title: 'Reviews' },
          ]}
          alignLeft
        />
        <div className="my-10 max-w-7xl mx-auto px-2 md:px-6 lg:px-8">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 sm:px-6 py-5 grid grid-cols-3 gap-4">
              <div className="col-span-3">
                <p className="mt-1 max-w-2xl text-sm text-gray-500">Restaurant: {review.restaurant_name || ''} </p>
                {!!review.order_number && (
                <p className="mt-1 max-w-2xl text-sm text-gray-500">Order:{' '}
                  <Link to={`/orders/${review.order_id}`} className="text-indigo-600 hover:text-indigo-900">
                    #{review.order_number || ''}
                  </Link>
                </p>
                )}
              </div>
            </div>
            <div className="border-t border-gray-200">
              <dl>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Date</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{getDateInCustomTimezone(review.date, review.timezone)}</dd>
                </div>
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Rating</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {review.rating}
                  </dd>
                </div>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Comment</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {review.comment}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </>
      )}
    </ListLayout>
  );
};
